import { OpenSansText } from "@Components/CustomText/OpenSansText"
import React from "react"
import { View } from "react-native"
import styles from "./styles"

const EmptyDiscussions = (props) => {
    const { label } = props
    return (
        <View style={styles.emptyDiscussionsContainer}>
            <OpenSansText fontSize={18}>{label ?? "Aucune discussion."}</OpenSansText>
        </View>
    )
}

export default EmptyDiscussions
